import {createGlobalStyle} from 'styled-components';
import fonttenancyeot from '../assets/fonts/tenancy/tenancy.eot';
import fonttenancysvg from '../assets/fonts/tenancy/tenancy.svg';
import fonttenancyttf from '../assets/fonts/tenancy/tenancy.ttf';
import fonttenancywoff from '../assets/fonts/tenancy/tenancy.woff';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: "FontTenancyIcon";
    src:url(${fonttenancyeot});
    src:url(${fonttenancyeot}?#iefix) format('embedded-opentype'),
      url(${fonttenancywoff}) format('woff'),
      url(${fonttenancyttf}) format('truetype'),
      url(${fonttenancysvg}#tenancy) format('svg');
    font-weight: normal;
    font-style: normal;
    font-variant: normal;
  }

  ::-moz-selection { /* Code for Firefox */
    color: #fff;
    background: #22487f;
  }

  ::selection {
    color: #fff;
    background: #22487f;
  }

  body {
    overflow-x: hidden;
    overflow-y: scroll;
  }

  ul, ol {
    margin: 5px 0 10px 0;
  }

  a {
    color: inherit;
  }

  img {
    max-width: 100%;
  }

  p {
    margin: 8px 0;
    padding: 0;
  }
`;

export default GlobalStyle;
